import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'date_range',
    viewPath: props.viewPath,
  })

  return function onChange(date_range) {
    change(date_range)
  }
}

export function useOnSave(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let change = useDataChange({
    context: 'filters',
    path: 'due_date',
    viewPath: props.viewPath,
  })

  let date_range = useDataValue({
    context: 'date_range',
    viewPath: props.viewPath,
  })

  return function onSave() {
    change(date_range)
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
